import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import { CollateralManagementServerData } from '@lk/api'

import { ThunkApi } from '../index.d'

export const convertUnicodeToLatin = createAsyncThunk<string, string, ThunkApi>(
  '[UTILITY] CONVERT_UNICODE_TO_LATIN',
  async (unicodeText, { extra, rejectWithValue }) => {
    const result = await extra.api.utility.unicodeToLatin(unicodeText)

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to convert unicode to latin')
  },
)

export const loadCollateralManagementSession = createAsyncThunk<CollateralManagementServerData, void, ThunkApi>(
  '[UTILITY] LOAD_COLLATERAL_MANAGEMENT_SESSION',
  async (_, { extra, rejectWithValue }) => {
    const result = await extra.api.utility.getCollateralManagementSession()

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load collateral management session')
  },
)

export const unloadCollateralManagementSession = createAction('[UTILITY] UNLOAD_COLLATERAL_MANAGEMENT_SESSION')
